import React, { Component } from 'react';
import { get, isString, uniq, uniqBy } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { webSafeFonts } from '../../../constants/availableFonts';
import './FontLibraryDropdown.scss';
import { noop } from '../../../../lib/utils';
import { Input as SparkInput } from 'sabre-spark-react';

class FontLibraryDropdown extends Component {
    static propTypes = {
        onChange: PropTypes.func
    };

    static defaultProps = {
        onChange: noop
    };

    constructor(props, ...args) {
        super(props, ...args);
        this.state = {
            search: ''
        };
    }
    onChange(value) {
        this.props.onChange(value);
    }

    renderFontsList(fontFamilies, total, key, title) {
        if (fontFamilies.length) {
            return [
                <li key={key} className="spark-menu__list-title">
                    {title} ({fontFamilies.length}/{total})
                </li>
            ].concat(
                fontFamilies.map(fontFamily => (
                    <li key={fontFamily.key} className="spark-menu__list-item" role="menuitem">
                        <a
                            className="spark-menu__list-link"
                            onClick={() => {
                                this.onChange(fontFamily.key);
                            }}
                            style={{ fontFamily: fontFamily.key }}
                        >
                            {fontFamily.label}
                        </a>
                    </li>
                ))
            );
        }
        return null;
    }

    onSearch = value => {
        this.setState({
            search: value
        });
    };
    render() {
        const fontFamilies = Object.keys(this.props.availableFontFamilies).map(v => ({ key: v, label: v }));
        const fontFamiliesFiltered = fontFamilies.filter(item => {
            return isString(item.label) && item.label.toLowerCase().startsWith(this.state.search.toLowerCase());
        });
        const filteredWebSafeFonts = webSafeFonts.filter(item => {
            return isString(item.label) && item.label.toLowerCase().startsWith(this.state.search.toLowerCase());
        });
        const filteredRecentFontFamilies = this.props.recentFonts
            .map(v => ({ key: v, label: v }))
            .filter(item => {
                return isString(item.label) && item.label.toLowerCase().startsWith(this.state.search.toLowerCase());
            });

        return (
            <div className="font-library-dropdown">
                <SparkInput icon="spark-icon-search" placeholder="Search Fonts..." onChange={this.onSearch} />
                <ul className="spark-menu__list font-library-dropdown__list scroll-elements">
                    {this.renderFontsList(
                        filteredRecentFontFamilies,
                        this.props.recentFonts.length,
                        'renderRecentlyUsedHeader',
                        'Recently used fonts'
                    )}
                    {this.renderFontsList(
                        fontFamiliesFiltered,
                        fontFamilies.length,
                        'recentUploadedFontsHeader',
                        'Uploaded fonts'
                    )}
                    {this.renderFontsList(
                        uniqBy(filteredWebSafeFonts, 'key'),
                        webSafeFonts.length,
                        'renderWebSafeFontsHeader',
                        'Web safe fonts'
                    )}
                </ul>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        availableFontFamilies: state.theme.fonts,
        recentFonts: uniq(
            Object.keys(state.theme.fontsUsage)
                .map(fontVariant => fontVariant.split(':')[0])
                .sort()
        )
    };
};

export default connect(mapStateToProps)(FontLibraryDropdown);



// WEBPACK FOOTER //
// ./src/components/widgets/FontConfigurator/FontLibraryDropdown.js